import CascadingAction from "@/action/CascadingAction"
import { applyService, sessionService } from "@/service"
import ActionId from "@/action/ActionId"
import {providerState, sessionState} from "@/state"
import ProviderError from "@/model/provider/ProviderError";
import router from "@/router";
import { removeAcceptOfferError } from "@/util/acceptOfferError"

class AcceptOfferAction extends CascadingAction {

    acceptOffer = true
    application = null

    constructor(providerKey, application) {
        super(ActionId.ACCEPT_OFFER, providerKey)
        this.application = application
    }

    async invoke() {
        sessionService.setMinTimeoutMillis(300000)
        try {
            removeAcceptOfferError()

            const response = await applyService.acceptOffer(this.providerKey, {
                application: this.application,
            })

            if (response.provider) {
                if ("error" === response.provider.responseCode) {
                    providerState.addError(this.providerKey, ProviderError.ACCEPT_OFFER_SOFT_ERROR, response)
                }
                providerState.setApplyResponse(this.providerKey, response.provider)
            }

            return response
        } catch (e) {
            if (e.response?.status === 400) {
                providerState.addError(this.providerKey, ProviderError.ACCEPT_OFFER_VALIDATION_ERROR, e.response)
            } else {
                providerState.addError(this.providerKey, ProviderError.ACCEPT_OFFER_ERROR, e.response)
            }
            throw e
        }
    }
}

export default AcceptOfferAction
